import { render } from "./DataAndEvolutionValue.vue?vue&type=template&id=25d82654&scoped=true"
import script from "./DataAndEvolutionValue.vue?vue&type=script&lang=js"
export * from "./DataAndEvolutionValue.vue?vue&type=script&lang=js"

import "./DataAndEvolutionValue.vue?vue&type=style&index=0&id=25d82654&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d82654"]])

export default __exports__